import script from "./BannerImageAndTitle.vue?vue&type=script&setup=true&lang=js"
export * from "./BannerImageAndTitle.vue?vue&type=script&setup=true&lang=js"

import "./BannerImageAndTitle.vue?vue&type=style&index=0&id=71fdb826&lang=scss&scoped=true"

import exportComponent from "/builds/strooka-jagaad/strooka-fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71fdb826"]])

export default __exports__